/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOf,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfFromJSON,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfFromJSONTyped,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfToJSON,
} from './PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOf';
import {
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesFromJSON,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesFromJSONTyped,
    PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesToJSON,
} from './PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates';

/**
 * response of GET /prtimes_media_lists/{media_list_id}/selected_media_lists/logs/only_dates
 * @export
 * @interface PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse
 */
export interface PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse
     */
    message: string;
    /**
     * 履歴がある日付のリスト
     * @type {Array<PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates>}
     * @memberof PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse
     */
    dates: Array<PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates>;
}

export function PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseFromJSON(json: any): PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse {
    return PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'dates': ((json['dates'] as Array<any>).map(PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesFromJSON)),
    };
}

export function PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseToJSON(value?: PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'dates': ((value.dates as Array<any>).map(PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesToJSON)),
    };
}

